import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICountyPublicWaterSystemResult, IRegionPublicWaterSystemResult } from '../../../types'
import {
  fetchAggregatedWaterSystemsAsync,
  fetchAggregatedWaterSystemsAsyncBuilder,
} from './asyncRequests'
import { defaultRegionViolations } from '../../../constants/Map'

export enum ZoomLevel {
  REGION = 'region',
  COUNTY = 'county',      
}

export interface PublicWaterSystemsAggregatesInitialState {
  regionsViolations: IRegionPublicWaterSystemResult[]
  countiesViolations: ICountyPublicWaterSystemResult[]
  zoomLevel: ZoomLevel
  loading: boolean
  error: string | null
  success: boolean
}

const initialState: PublicWaterSystemsAggregatesInitialState = {
  regionsViolations: defaultRegionViolations,
  countiesViolations: [],
  zoomLevel: ZoomLevel.REGION,
  loading: false,
  error: null,
  success: false,
}

export const PublicWaterSystemsAggregatesSlice = createSlice({
  name: 'publicWaterSystemAggregateSlice',
  initialState,
  reducers: {
    setZoomLevel: (state, action: PayloadAction<ZoomLevel>) => {
      state.zoomLevel = action.payload
    },
    resetWaterSystemMetricsData: (state) => {
      state.regionsViolations = initialState.regionsViolations
      state.countiesViolations = initialState.countiesViolations
      state.zoomLevel = initialState.zoomLevel
      state.loading = initialState.loading
      state.error = initialState.error
      state.success = initialState.success
    },
  },
  extraReducers: (builder) => {
    fetchAggregatedWaterSystemsAsyncBuilder(builder)
  },
})

export const PublicWaterSystemsAggregatesActions = {
  ...PublicWaterSystemsAggregatesSlice.actions,
  fetchAggregatedWaterSystemsAsync,
}

export const PublicWaterSystemsAggregatesReducer = PublicWaterSystemsAggregatesSlice.reducer
